module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "h8"
  }, [_vm._t("default"), _vm._v(" "), _vm._l((_vm.links), function(item) {
    return (item.link && item.label) ? _c('li', [(item.link.type === 'Link.document') ? [_c('router-link', {
      attrs: {
        "to": _vm.internalRt(item.link.type, item.link.value.document.uid)
      }
    }, [_vm._v(_vm._s(item.label.value[0].text))])] : (item.link.type === 'Link.web') ? [_c('a', {
      attrs: {
        "href": item.link.value.url,
        "target": item.link.value.target,
        "rel": "noopener"
      }
    }, [_vm._v(_vm._s(item.label.value[0].text))])] : _vm._e()], 2) : _vm._e()
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-66e7217c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FooterLinks.vue
// module id = 391
// module chunks = 1